import React from "react";

const Privacy = () => (
  <div className="bg-gray-900 text-white flex items-center justify-center p-6">
    <div className="max-w-3xl text-center">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        This application (UA-CAR) respects your privacy. We do not collect, store, or share any personal information.
      </p>
      <p className="mb-4">
        UA-CAR may request permissions such as location for specific features, but this data is not stored or shared with third parties.
      </p>
      <p className="mb-4">
        By using the app, you agree to this policy. This policy may be updated, and any changes will be reflected on this page.
      </p>
      <p>
        If you have any questions, please contact us at: <strong>italo@lonkansoft.pro</strong>
      </p>
    </div>
  </div>
);

export default Privacy;
